import { css } from 'styled-system/css';
import { jupiterContainer } from 'styled-system/patterns';

export const homePageStyle = {
	jupiterHome: jupiterContainer({
		'--body-bg': 'colors.jupiter.main.bodyBg',
		flexDir: 'column',
		gap: '24px',
		width: '100%',
		'& .home-banner': {
			width: '100%',
		},
	}),
	tabSwitch: css({
		base: {
			h: '40px',
			fontSize: '14px',
			fontWeight: '500',
		}
	}),
}